import { render } from "./setting.vue?vue&type=template&id=3e5a7a9c&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import "./setting.vue?vue&type=style&index=0&id=3e5a7a9c&lang=scss&scoped=scoped"
import "./setting.vue?vue&type=style&index=1&id=3e5a7a9c&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5a7a9c"]])

export default __exports__